import React, {useEffect, useState, useRef} from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {styled} from '@mui/system';

const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];

    return data.map(row => ({
        id: row.value.id,
        ...row.value,
        status: row.value.unblocked ? 'Unblocked' : 'Blocked',
    }));
}

const GeoEdgeBlockedCreativesDataGrid = ({data}) => {
    const [rows, setRows] = useState(processData(data));
    const gridRef = useRef(null);

    useEffect(() => {
        setRows(processData(data));
    }, [data]);

    const has = (field) => rows.some(row => field in row);

    let columns = [];

    columns.push({field: 'id', headerName: 'ID', width: 70});
    if (has('creative_id')) columns.push({field: 'creative_id', headerName: 'Creative ID', width: 250});
    if (has('dsp_id')) columns.push({field: 'dsp_id', headerName: 'DSP ID', width: 100});
    if (has('dsp_name')) columns.push({field: 'dsp_name', headerName: 'DSP Name', width: 200});
    if (has('ssp_id')) columns.push({field: 'ssp_id', headerName: 'SSP ID', width: 100});
    if (has('ssp_name')) columns.push({field: 'ssp_name', headerName: 'SSP Name', width: 200});
    if (has('incident_count')) columns.push({field: 'incident_count', headerName: 'Incident Count', width: 120});
    if (has('trigger_type')) columns.push({field: 'trigger_type', headerName: 'Trigger Type', width: 150});
    if (has('trigger_category')) columns.push({field: 'trigger_category', headerName: 'Trigger Category', width: 150});
    if (has('share_link')) {
        columns.push({
            field: 'share_link',
            headerName: 'Share Link',
            width: 150,
            renderCell: (params) => params.value
                ? <a href={params.value} target="_blank" rel="noreferrer">Open in GeoEdge</a>
                : '',
        });
    }
    if (has('campaign_id')) columns.push({field: 'campaign_id', headerName: 'Campaign ID', width: 120});
    if (has('account_id')) columns.push({field: 'account_id', headerName: 'Account ID', width: 120});
    if (has('incident_key')) columns.push({field: 'incident_key', headerName: 'Incident Key', width: 200});
    if (has('incident_dt')) columns.push({field: 'incident_dt', headerName: 'Incident Date', width: 120});
    if (has('list_id')) columns.push({field: 'list_id', headerName: 'List ID', width: 100});
    if (has('list_name')) columns.push({field: 'list_name', headerName: 'List Name', width: 300});
    if (has('blocked')) columns.push({field: 'blocked', headerName: 'Blocked', width: 120});
    if (has('unblocked')) columns.push({field: 'unblocked', headerName: 'Unblocked', width: 120});
    if (has('unblocked')) columns.push({field: 'status', headerName: 'Status', width: 100});
    if (has('irtb_company_id')) columns.push({field: 'irtb_company_id', headerName: 'Company', width: 200});
    if (has('manager')) columns.push({field: 'manager', headerName: 'Manager', width: 200});
    if (has('created_at')) columns.push({field: 'created_at', headerName: 'Created At', width: 120});

    if (data.length === 0) {
        return null;
    } else {

        return (

            <div style={{height: 800, width: '100%'}} ref={gridRef}>
                <StyledDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={25}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    disableRowSelectionOnClick
                />
            </div>
        );
    }
};

export default GeoEdgeBlockedCreativesDataGrid;
